<template>
  <div class="line-chart__wrapper">
    <chartjs-line
      :chart-data="chartData"
      :chart-options="computedChartConfig.chartOptions"
      :plugins="computedChartConfig.plugins"
      :styles="computedChartConfig.styles"
      :css-classes="computedChartConfig.cssClasses" />
  </div>
</template>

<script>
import { Line } from 'vue-chartjs/legacy/index.js';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
);

const formatLabel = (str) => {
  if (str.length > 16) {
    return `${str.substr(0, 16).trim()}...`;
  }

  return str;
};

export default {
  name: 'line-chart',
  components: {
    'chartjs-line': Line,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    tooltipColoringRule: {
      type: Function,
      default: () => () => '#000000',
    },
    scaleYText: {
      type: String,
      default: 'Cobertura (%)',
    },
    scaleXText: {
      type: String,
      default: 'Ano',
    },
  },
  computed: {
    computedChartConfig() {
      return {
        styles: {
          position: 'relative',
          height: '280px',
        },
        cssClasses: '',
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
              position: 'nearest',
              usePointStyle: true,
              boxPadding: 2,
              backgroundColor: 'rgba(255,255,255,1)',
              titleColor: 'rgba(112,112,112,1)',
              bodyColor: 'rgba(112,112,112,1)',
              bodyFont: {
                weight: 600,
              },
              footerColor: 'rgba(112,112,112,1)',
              padding: 16,
              borderWidth: 1,
              borderColor: 'rgba(222,222,222,1)',
              callbacks: {
                label: (context) => {
                  const { label } = context.dataset;
                  const formattedLabel = formatLabel(label);

                  return `${formattedLabel} ${context.formattedValue}%`;
                },
                labelTextColor: (context) => this.tooltipColoringRule(context.parsed.y),
              },
            },
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: this.scaleXText,
                font: { size: 12, weight: 600 },
              },
            },
            y: {
              display: true,
              min: 0,
              grid: {
                borderDash: [3],
                borderDashOffset: 10.0,
              },
              title: {
                display: true,
                text: this.scaleYText,
                font: { size: 12, weight: 600 },
              },
            },
          },
        },
        plugins: [
          {
            afterDraw: (chart) => {
              /* eslint-disable no-underscore-dangle */
              if (chart.tooltip?._active?.length) {
                const xValue = chart.tooltip._active[0].element.x;
                const yAxis = chart.scales.y;
                const context = chart.ctx;
                context.save();
                context.beginPath();
                context.moveTo(xValue, yAxis.top);
                context.lineTo(xValue, yAxis.bottom);
                context.globalCompositeOperation = 'destination-over';
                context.lineWidth = 1;
                context.strokeStyle = '#e5e5e5';
                context.setLineDash([6]);
                context.stroke();
                context.restore();
              }
              /* eslint-enable no-underscore-dangle */
            },
          },
        ],
      };
    },
  },
};
</script>
